import botspotLogo from '../../assets/botspot_logo_horizontal.png';
import './AuthLogo.css';

/** Keep the mascot's original colors while adapting the wordmark to its surface. */
export default function AuthLogo() {
  return (
    <span className="auth-brand-logo">
      <img
        alt="BotSpot by LumiWealth"
        className="auth-brand-logo__wordmark"
        height={429}
        src={botspotLogo}
        width={1385}
      />
      <img
        alt=""
        aria-hidden="true"
        className="auth-brand-logo__mascot"
        height={429}
        src={botspotLogo}
        width={1385}
      />
    </span>
  );
}
